/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import styled from "styled-components";
import { useTheme } from "@material-ui/core/styles";
import NewReleasesIcon from "@material-ui/icons/NewReleases";
import amber from "@material-ui/core/colors/yellow";

const StyledBanner = styled.div`
  margin: ${(props) => props.theme.spacing(2)}px;
  padding: ${(props) => props.theme.spacing(2)}px;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid ${amber[700]};
  text-align: center;
`;

const AlertBanner = ({ message }) => {
  const theme = useTheme();
  return (
    <StyledBanner theme={theme}>
      <NewReleasesIcon
        style={{
          color: amber[700],
          marginTop: "4px",
          position: "relative",
          top: "2px",
        }}
      />
      <span
        style={{
          display: "inline",
          paddingLeft: theme.spacing(1),
          fontSize: "1.5rem",
        }}
      >
        {message}
      </span>
    </StyledBanner>
  );
};

export default AlertBanner;
